<template>

  <div class="lotti-my-sessions-module">

    <div class="lotti-module-title">{{ (leadView ? 'Alle' : 'Meine') }} Zeiteinträge</div>

    <div class="lotti-module-nav">

      <el-button
          icon="el-icon-plus"
          type="success"
          @click="$router.push('session/0')"
          circle>
      </el-button>

      <el-input
          size="medium"
          placeholder="Suchtext"
          v-model="searchForm.text">
      </el-input>

      <el-date-picker
          v-model="searchForm.dateTo"
          size="medium"
          type="date"
          format="dd.MM.yyyy"
          placeholder="Ende"
          :picker-options="datePickerHelper.getOptionsDateRange(searchForm.dateFrom, true)">
      </el-date-picker>

      <el-date-picker
          v-model="searchForm.dateFrom"
          size="medium"
          type="date"
          format="dd.MM.yyyy"
          placeholder="Start"
          :picker-options="datePickerHelper.getOptionsDateRange(searchForm.dateTo, false)">
      </el-date-picker>

      <el-button
          size="mini"
          class="lotti-search-info-popover"
          v-popover:popover-search-child
          round>
        ?
      </el-button>

      <el-popover
          ref="popover-search-child"
          placement="top-start"
          width="250"
          trigger="hover"
          content="Durchsuchbare Felder: ID, Dauer, Kategorie, Status, Beschreibung, Logopädin">
      </el-popover>

    </div>

    <el-table :data="tableData"
              class="lotti-module-table"
              ref="sessionTable"
              height="490px"
              stripe
              :row-key="tableData.id"
              :default-sort="searchForm.sortingParams"
              @sort-change="setSortingParams"
              @row-click="openSession"
              @hook:mounted="tableMounted"
              @hook:beforeDestroy="tableBeforeDestroy"
              style="width: 100%">

      <!--dynamic with column1 -->
      <el-table-column
          prop="child_name"
          label="Beschreibung"
          min-width="150px"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

      <!--dynamic with column2 -->
      <el-table-column
          v-if="leadView"
          prop="therapist_name"
          label="Logopädin"
          min-width="120px"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="datetime_start"
          label="Datum"
          sortable="custom"
          width="100px"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ datePickerHelper.formatUTCDateCH(scope.row.datetime_start) }}
        </template>
      </el-table-column>

      <el-table-column
          prop="duration"
          label="Dauer"
          sortable="custom"
          width="90px"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ scope.row.duration }} min
        </template>
      </el-table-column>

      <el-table-column
          prop="category"
          width="155px"
          label="Kategorie"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="status"
          label="Status"
          width="130px"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

    </el-table>

  </div>

</template>

<script>
import auth from '../../auth.js';
import Vue from "../../main";
import datePickerHelper from "../../Helpers/DatePickerHelper";

export default {

  props: {
    leadView: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      auth: auth,
      datePickerHelper: datePickerHelper,

      submitDelay: 400,//ms
      submitTimer: null,

      pageNumber: 0,
      tableData: [],
      thereIsMoreData: true,
      allowedSorting: ['ascending', 'descending'],
      tableSelector: '.lotti-my-sessions-module .el-table__body-wrapper',
      tableElement: null,

      searchForm: {

        dateTo: '',
        dateFrom: '',
        text: '',

        sortingParams: {
          prop: 'datetime_start',
          order: 'descending'
        }
      }
    }
  },

  methods: {

    setSortingParams(column, prop, order) {
      this.searchForm.sortingParams.prop = column.prop;
      this.searchForm.sortingParams.order = column.order;
    },

    openSession(row, event, column) {
      this.$router.push({
        name: 'session',
        params: {
          sessionId: row.id
        }
      })
    },

    getAllMySession() {

      //increase page number BEFORE submitting!
      this.pageNumber += 1;

      Vue.http.get(
          'api/v1/session/get-all-my',
          {
            params: {
              text: this.searchForm.text,
              dateFrom: this.searchForm.dateFrom ? this.datePickerHelper.formatUTCDateUS(this.searchForm.dateFrom) : null,
              dateTo: this.searchForm.dateTo ? this.datePickerHelper.formatUTCDateUS(this.searchForm.dateTo) : null,
              column: this.searchForm.sortingParams.prop,
              order: this.searchForm.sortingParams.order === 'ascending' ? 'asc' : 'desc',
              page: this.pageNumber,
              lead: this.leadView,
            }
          }
      ).then(response => {

        //concat the data at the end of the already loaded data if != null
        if (response.data) {
          this.tableData = this.tableData.concat(response.data);
        } else {
          //block further requests, there is no more data
          this.thereIsMoreData = false;
        }

      }, response => {
        // this.showError(response.data.message);
      })
    },

    resetTableLoader() {
      this.pageNumber = 0;//reset page size on filter change
      this.tableData = [];//reset tableData as well

      //allow loading for further data after reset
      this.thereIsMoreData = true;
    },

    sendDelayedSearchRequest() {
      //if timer exists: clear
      if (this.submitTimer) {
        clearTimeout(this.submitTimer);
        this.submitTimer = null;
      }
      this.submitTimer = setTimeout(() => {
        this.getAllMySession();
      }, this.submitDelay);
    },

    handleOnInfiniteScroll(event) {
      //implement infinite scroll
      if (
          this.thereIsMoreData &&
          Math.ceil(this.tableElement.clientHeight + this.tableElement.scrollTop) >= this.tableElement.scrollHeight
      ) {
        // you're at the bottom of the page
        this.getAllMySession();
      }
    },

    tableMounted() {
      //select table element first
      this.tableElement = document.querySelector(this.tableSelector);
      //add event listener secondly
      this.tableElement.addEventListener('scroll', this.handleOnInfiniteScroll);
    },

    tableBeforeDestroy() {
      this.tableElement.removeEventListener('scroll', this.handleOnInfiniteScroll);
    }
  },

  watch: {
    searchForm: {
      handler(newValue, oldValue) {
        this.resetTableLoader();//reset values on each form filter change
        this.sendDelayedSearchRequest();
      },
      deep: true,
    }
  },

  beforeMount() {

    //get all therapists in selected service
    this.getAllMySession();
  },

  mounted() {

  }
}

</script>